import React from "react";

/**
 * Bhawar Sales Corporation logo.
 *
 * The PNG has dark ink on transparent background. On dark backgrounds we
 * invert to white so it stays readable — the caller signals that via `tone`.
 *
 * Usage:
 *   <BhawarLogo tone="light" />  // on dark surface: renders white
 *   <BhawarLogo tone="dark" />   // on light surface: renders as-is
 */
export default function BhawarLogo({ height = 44, tone = "dark", className = "", ...rest }) {
  // Native aspect ratio ≈ 2000 / 648 ≈ 3.086
  const width = Math.round(height * (2000 / 648));
  const style = tone === "light"
    ? { filter: "brightness(0) invert(1)" }        // any dark ink → pure white
    : {};                                          // keep original ink on light bg
  return (
    <img
      src="/bhawar-logo.png"
      alt="Bhawar Sales Corporation"
      width={width}
      height={height}
      style={style}
      className={`select-none ${className}`}
      draggable={false}
      {...rest}
    />
  );
}

// Kept for backwards compatibility with existing imports.
export function BhawarWordmark({ size = 40, tone = "dark", className = "", ...rest }) {
  return <BhawarLogo height={size} tone={tone} className={className} {...rest} />;
}
